import { render, staticRenderFns } from "./CDocumentFiles.vue?vue&type=template&id=ec002776&scoped=true&"
import script from "./CDocumentFiles.vue?vue&type=script&lang=js&"
export * from "./CDocumentFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec002776",
  null
  
)

export default component.exports